import { DatabaseOutlined, LoginOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import "./NavBar.css";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

const items = [
  
  {
    key: "login",
    label: "Login",
    icon: <LoginOutlined />,
  },
];

const NavBar = () => {
  const [current, setCurrent] = useState("");
  const history = useHistory();

  const onClick = (e) => {
    const { key } = e;
    setCurrent(key);

    if (key === "login") {
      handleLogin();
    }

    const item = findMenuItemByKey(items, key);
    if (item && item.path) {
      history.push(item.path);
    }
  };

  const findMenuItemByKey = (menuItems, key) => {
    for (let item of menuItems) {
      if (item.key === key) {
        return item;
      }
      if (item.children) {
        const childItem = findMenuItemByKey(item.children, key);
        if (childItem) {
          return childItem;
        }
      }
    }
    return null;
  };

  const handleLogin = () => {
    localStorage.clear();
    return history.push("/login");
  };

  return (
    <>
      <Menu
        className="navbar"
        onClick={onClick}
        selectedKeys={[current]}
        mode="horizontal"
        items={items}
        theme="light"
      />
    </>
  );
};

export default NavBar;
